export default __webpack_public_path__ + "static/wizard-fade-100-2d3ce06ac7d2f4904c8ff881fde5a1be.gif";